"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
/** Stylesheets */
var icons = require("../../../styles/att-icon-login.scss");
var styles = require("./IconHeading.scss");
var IconHeading = /** @class */ (function (_super) {
    __extends(IconHeading, _super);
    function IconHeading() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    IconHeading.prototype.render = function () {
        return (React.createElement("div", { className: [styles.iconHeadingWrapper].join(' ') },
            React.createElement("div", { className: [styles.iconWrapper, styles.iconBg].join(' '), "aria-label": this.props.options.accessibilityText, role: "img", "data-test-id": this.props.testId },
                React.createElement("i", { className: [icons.attIconLogin, this.props.options.iconClassName].join(' ') })),
            React.createElement("div", { "data-test-id": this.props.testId + '_Title' },
                React.createElement("h1", null, this.props.data.title))));
    };
    return IconHeading;
}(React.Component));
exports.default = IconHeading;
//# sourceMappingURL=IconHeading.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/login-ui/components/common/IconHeading/IconHeading.js
// module id = 578
// module chunks = 8